import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';

import { selectCategoryMetadata } from './category';

export const selectCategoryId = (
  state: SpartacuxProductDiscoveryDomainState,
): number | undefined => selectCategoryMetadata(state)?.id;
